import { keysToCamelCase } from "zod-to-camel-case";

import type {
  LessonOutline,
  LessonOutlineCamel,
} from "@/schema/public/components/lessonOutline/lessonOutline.schema";

export const lessonOutlineFixture = ({
  overrides = {},
}: {
  overrides?: Partial<LessonOutline>;
} = {}): LessonOutline => ({
  lesson_outline: "Example lesson outline",
  ...overrides,
});

export const lessonOutlineFixtureCamel = ({
  overrides = {},
}: {
  overrides?: Partial<LessonOutlineCamel>;
} = {}): LessonOutlineCamel =>
  keysToCamelCase(
    lessonOutlineFixture({
      overrides: overrides as Partial<LessonOutline>,
    }),
  );
